'use client';
import * as e from 'react';

function useDidImmutableValueChange(r) {
    return e.useRef(r).current !== r;
}

export { useDidImmutableValueChange };
